// components/Common/RouteTracker.js
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { pushToHistory } from "../../utils/history";

const RouteTracker = ({ children }) => {
  const location = useLocation();

  useEffect(() => {
    pushToHistory(location.pathname);
  }, [location.pathname]);

  return children;
};

export default RouteTracker;
